import React from 'react'
import Link from 'gatsby-link'
import { Button, Form, Divider, Segment, Breadcrumb, Icon } from 'semantic-ui-react'
import Helmet from 'react-helmet'

const ContactPage = () => (
  <div style={{maxWidth: 1260, margin: '0 auto'}}>
  <Helmet>
      <title>Contact | Find Growth Tools</title>
    </Helmet>
  <Segment basic>
    <Breadcrumb>
      <Breadcrumb.Section>
        <Link to="/" 	style={{color: '#dcddde'}}>
          <Icon name="angle left" />Home
        </Link>
      </Breadcrumb.Section>
    </Breadcrumb>
    </Segment>
  <h1 style={{
      fontSize: '3.25rem',
      color: '#fff'
    }}>Get in touch</h1>
    <br/>
   <div style={{maxWidth: 960, margin: '0 auto'}}>
   <p style={{fontSize: '1.25em', color: '#fff'}}>Questions, feedback, or just want to say hi? Get in touch using the form below.</p>
    <div>
      <Segment>
    <Form
        name="contactForm"
        // netlify-honeypot="bot-field"
        action="/thanks"
        // netlify
        size="medium"
        method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      >
      <input type="hidden" name="form-name" value="contactForm" />
        <Form.Input
          fluid
          type="text"
          label="Your Name"
          required="true"
          placeholder="Your Name"
          name="name"
        />
        <Form.TextArea label="Your message" required="true" placeholder="Your message" name="message" />
        <Form.Group>
          <Form.Field>
            <Form.Input
              type="email"
              label="Your email"
              required="true"
              placeholder="Your Email"
              name="email"
            />
          </Form.Field>
        </Form.Group>
        <Button primary type="submit">Send message</Button>

        <p
          style={{
            display: 'none',
          }}
        >
          <input name="bot-field" />
        </p>
      </Form>
      </Segment>
    </div>
    
</div>
  </div>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js